import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: 0
}

export const linkSlice = createSlice({
    name:"link",
    initialState:initialState,
    reducers:{
        linkValue:(state, payload)=>{
            state.value=payload
        }
    },

})

export const {linkValue} = linkSlice.actions
export default linkSlice.reducer